export const reconnect = 'Pit stop! Refresh to continue your conversation.';
export const refreshButton = 'Refresh Chat';
